import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseCompetingTimeSlotsComponent } from '~app/app/competing-time-slots/abstract-components/base-competing-time-slots.component';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { CompetingTimeSlotsCreationDialogComponent } from '../../modals/competing-time-slots-creation-dialog/competing-time-slots-creation-dialog.component';

@Component({
  selector: 'competing-time-slots-datatable',
  standalone: false,
  templateUrl: './competing-time-slots-datatable.component.html',
  styleUrl: './competing-time-slots-datatable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingTimeSlotsDatatableComponent extends BaseCompetingTimeSlotsComponent {
  private _dialogService = inject(DialogService);
  displayedColumns: string[] = [
    'timeSlot',
    'media',
    'numberOfAds',
    'dominantCompetitor'
  ];

  dataSource = [
    {
      timeSlot: '18:00 - 19:00',
      media: 'Télévision',
      numberOfAds: 5,
      dominantCompetitor: 'Canal+'
    },
    {
      timeSlot: '08:00 - 09:00',
      media: 'Radio',
      numberOfAds: 3,
      dominantCompetitor: 'Orange'
    }
  ];

  openAddDialog(): void {
    this._dialogService.open({
      component: CompetingTimeSlotsCreationDialogComponent,
      fullscreen: true
    });
  }
}
